export default "__VITE_ASSET__BhVNmMsG__"